/* import __COLOCATED_TEMPLATE__ from './choose-signal-chain-part.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import Constants from '../../utils/constants';
import { tracked } from '@glimmer/tracking';

export default class ChooseSignalChainPartModal extends Component {
  @tracked modalProperties = null;

  get modalType() {
    return Constants.MODAL_TYPES.CHOOSE_SIGNAL_CHAIN_PART.value;
  }

  get availableItems() {
    return this.args.model.signalChainHandler && this.args.model.signalChainHandler.availableItems
      ? this.args.model.signalChainHandler.availableItems
      : [];
  }

  get signalChainItem() {
    if (!this.modalProperties) return null;

    const signalChainItemPstId = this.availableItems.find(
      (item) => item.config.id === this.modalProperties.signalChainItemPstId,
    );
    return signalChainItemPstId;
  }

  get signalChainHandlerGridData() {
    const data = this.args.model && this.args.model.signalChainHandler && this.args.model.signalChainHandler.gridData;
    if (!data) return null;

    return this.args.model.signalChainHandler.gridData;
  }

  get gridData() {
    if (!this.signalChainItem) return { data: null, gridData: null };
    const pstId = this.signalChainItem.config.pst.id;
    const gridData = this.signalChainHandlerGridData;
    if (!(pstId in gridData)) return { data: null, gridData: null };
    return gridData[pstId];
  }

  @action setSelectedItem(selectedItem) {
    if (selectedItem) {
      this.signalChainItem.selected = selectedItem;
    }
  }

  @action onPartSelection() {
    if (this.args.updateAppData) this.args.updateAppData();
    this.args.model.chartHandler.update(Constants.CHART_TYPES.ERROR_DISTRIBUTION);
  }

  @action onPartModalShow() {
    if (this.modalType in this.args.model.modalHandler.data) {
      this.modalProperties = this.args.model.modalHandler.data[this.modalType];
    } else {
      console.error('The signal chain part properties were not found in the modal data');
    }
  }

  @action onPartModalHide() {
    this.modalProperties = null;
  }
}
